// GlowStrike ES cart drawer — open/close, add-to-cart interception, quantity change, line
// removal. Talks to the standard Shopify AJAX Cart API (/cart/add.js, /cart/change.js,
// /cart.js) directly; does not depend on Horizon's cart JS or section-rendering endpoints.
// Re-implemented from scratch against the competitor's documented behavior (STRUCTURE.md
// "Cart Drawer"): opens on add-to-cart, shows line items, qty stepper, remove, checkout link.
(function () {
  // Language for dynamically-rendered cart-drawer markup (line items added via AJAX after
  // /cart/add.js). The server-rendered drawer shell (snippets/gs-cart-drawer.liquid) picks its
  // strings from template.suffix == 'de' at render time; this mirrors that choice via the
  // <html lang> attribute layout/gs.liquid already sets the same way, so both stay in sync
  // without a second source of truth.
  var isDe = document.documentElement.lang === 'de';
  var STR = isDe
    ? {
        decrease: 'Menge verringern',
        qty: 'Menge',
        increase: 'Menge erhöhen',
        removePrefix: 'Entfernen: ',
        remove: 'Entfernen',
        cartError: 'Der Warenkorb konnte nicht aktualisiert werden.',
      }
    : {
        decrease: 'Decrease quantity',
        qty: 'Quantity',
        increase: 'Increase quantity',
        removePrefix: 'Remove ',
        remove: 'Remove',
        cartError: 'The cart could not be updated.',
      };

  function drawer() {
    return document.querySelector('[data-gs-cart-drawer]');
  }

  function money(cents) {
    try {
      return (
        (window.Shopify && window.Shopify.formatMoney)
          ? window.Shopify.formatMoney(cents, window.Shopify.money_format)
          : '$' + (cents / 100).toFixed(2)
      );
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  var lastFocus = null;

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    lastFocus = document.activeElement;
    el.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    var panel = el.querySelector('[data-gs-cart-content]');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var el = drawer();
    if (!el || el.dataset.open !== 'true') return;
    el.dataset.open = 'false';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lineItemHtml(item) {
    var optionsHtml = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      optionsHtml = '<p class="cs-cart-item__options">' + escapeHtml(item.variant_title) + '</p>';
    }
    return (
      '<li class="cs-cart-item" data-gs-cart-item data-key="' + item.key + '">' +
        '<a class="cs-cart-item__media" href="' + item.url + '">' +
          '<img src="' + (item.image || '') + '" alt="" width="80" height="80" loading="lazy">' +
        '</a>' +
        '<div>' +
          '<a class="cs-cart-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          optionsHtml +
        '</div>' +
        '<div class="cs-cart-item__price" data-gs-cart-item-price>' + money(item.final_line_price) + '</div>' +
        '<div class="cs-cart-item__actions">' +
          '<div class="cs-stepper" data-gs-qty-stepper>' +
            '<button type="button" data-gs-qty-decrease aria-label="' + STR.decrease + '">&minus;</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-gs-qty-input aria-label="' + STR.qty + '" inputmode="numeric">' +
            '<button type="button" data-gs-qty-increase aria-label="' + STR.increase + '">&plus;</button>' +
          '</div>' +
          '<button type="button" class="cs-cart-item__remove" data-gs-cart-remove aria-label="' + STR.removePrefix + escapeHtml(item.product_title) + '">' +
            '<svg class="cs-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '<span>' + STR.remove + '</span>' +
          '</button>' +
        '</div>' +
      '</li>'
    );
  }

  function render(cart) {
    var el = drawer();
    if (!el) return;

    el.querySelector('[data-gs-cart-content]').dataset.cartCountValue = cart.item_count;

    var empty = el.querySelector('[data-gs-cart-empty]');
    var items = el.querySelector('[data-gs-cart-items]');
    var payments = el.querySelector('[data-gs-cart-payments]');
    var foot = el.querySelector('[data-gs-cart-foot]');

    if (cart.item_count === 0) {
      if (empty) empty.hidden = false;
      if (items) { items.hidden = true; items.innerHTML = ''; }
      if (payments) payments.hidden = true;
      if (foot) foot.hidden = true;
    } else {
      if (empty) empty.hidden = true;
      if (items) {
        items.hidden = false;
        items.innerHTML = cart.items.map(lineItemHtml).join('');
      }
      if (payments) payments.hidden = false;
      if (foot) {
        foot.hidden = false;
        var subtotal = foot.querySelector('[data-gs-cart-subtotal]');
        if (subtotal) subtotal.textContent = money(cart.total_price);
      }
    }

    document.querySelectorAll('[data-gs-cart-count]').forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refresh(openAfter) {
    return fetchCart().then(function (cart) {
      render(cart);
      if (openAfter) openDrawer();
      return cart;
    });
  }

  function changeLine(key, quantity) {
    var el = drawer();
    if (el) el.querySelector('.cs-cart').setAttribute('aria-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        return cart;
      })
      .finally(function () {
        if (el) el.querySelector('.cs-cart').removeAttribute('aria-busy');
      });
  }

  // Intercept product-form submits site-wide (buy box tiers post standard /cart/add forms).
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();

    var submitButtons = form.querySelectorAll('[type="submit"]');
    submitButtons.forEach(function (btn) { btn.setAttribute('aria-disabled', 'true'); });

    var body = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var errorEl = form.querySelector('[data-product-error]');
          if (errorEl) {
            errorEl.textContent = data.description || data.message || STR.cartError;
            errorEl.hidden = false;
          }
          return;
        }
        refresh(true);
      })
      .catch(function () {})
      .finally(function () {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-disabled'); });
      });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-gs-cart-open]')) {
      event.preventDefault();
      refresh(false).then(function () { openDrawer(); });
      return;
    }
    if (event.target.closest('[data-gs-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    var remove = event.target.closest('[data-gs-cart-remove]');
    if (remove) {
      var li = remove.closest('[data-gs-cart-item]');
      if (li) changeLine(li.dataset.key, 0);
      return;
    }
    var dec = event.target.closest('[data-gs-qty-decrease]');
    if (dec) {
      var liDec = dec.closest('[data-gs-cart-item]');
      var inputDec = liDec.querySelector('[data-gs-qty-input]');
      var nextDec = Math.max(0, Number(inputDec.value || 0) - 1);
      inputDec.value = nextDec;
      changeLine(liDec.dataset.key, nextDec);
      return;
    }
    var inc = event.target.closest('[data-gs-qty-increase]');
    if (inc) {
      var liInc = inc.closest('[data-gs-cart-item]');
      var inputInc = liInc.querySelector('[data-gs-qty-input]');
      var nextInc = Number(inputInc.value || 0) + 1;
      inputInc.value = nextInc;
      changeLine(liInc.dataset.key, nextInc);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-gs-qty-input]');
    if (!input) return;
    var li = input.closest('[data-gs-cart-item]');
    changeLine(li.dataset.key, Math.max(0, Math.floor(Number(input.value) || 0)));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  window.gsCart = { open: openDrawer, close: closeDrawer, refresh: refresh };
})();
